import React, { useContext, useState } from 'react';

import {
  IonContent,
  IonButton,
  useIonViewWillEnter,
  useIonViewDidLeave,
} from '@ionic/react';

import { Auth, useAuth } from '../services/AuthService';
import { AuthActionBuilder } from 'ionic-appauth';
import { RouteComponentProps } from 'react-router';
import { useWP } from '../hooks/WPHooks';
import { Subscription } from 'rxjs';
import { ActionCard } from '../components/debug/action-card';
import { AppPage } from '../AppContent';
import { UserInfoCard } from '../components/debug/user-info-card';
import { LogsCard } from '../components/debug/logs-card';
import { useLogs } from '../services/LogService';
import { EnvCard } from '../components/debug/env-card';
import { AuthCard } from '../components/debug/auth-card';
import { ActionType } from '../state/GlobalState';
import { AppContext } from '../state/AppContextProvider';

interface DebugPageProps extends RouteComponentProps {}

export const DebugPage: React.FC<DebugPageProps> = (props: DebugPageProps) => {
  const { dispatch } = useContext(AppContext);
  const [action, setAction] = useState(AuthActionBuilder.Init);
  const [user, setUser] = useState();
  let subs: Subscription[] = [];

  const logs = useLogs();

  const auth = useAuth();

  const { wp } = useWP();

  useIonViewWillEnter(() => {
    subs.push(
      auth.events$.subscribe((action) => {
        setAction(action);
      }),
      auth.user$.subscribe((user) => {
        setUser(user);
      })
    );
  });

  useIonViewDidLeave(() => {
    subs.forEach((sub) => sub.unsubscribe());
  });

  async function handleSignOut(e: any) {
    Auth.setWpToken('simulateTokenExpiration');
  }

  async function handleSignOutGia(e: any) {
    const logoutUrl = `${process.env.REACT_APP_AUTH_URL}/?logout=1`;
    const browser = Auth.getInstance(console).getBrowser();
    await browser.showWindow(logoutUrl);
    setTimeout(() => browser.closeWindow(), 1000);
  }

  function handleRefresh(e: any) {
    e.preventDefault();
    auth.refreshToken();
  }

  function handleGetUserDetails(e: any) {
    e.preventDefault();
    auth.loadUserInfo();
  }

  function handleGetHouses(e: any) {
    e.preventDefault();
    wp.getHouses();
  }

  function handleClearLogs(e: any) {
    e.preventDefault();
    dispatch({ type: ActionType.ClearLogs });
  }

  return (
    <AppPage scrollable={true}>
      <IonContent className="p-0 scrollable scroll-y">
        <IonButton onClick={handleGetUserDetails}>Gia User Details</IonButton>
        <IonButton onClick={handleRefresh}>Refresh Gia Token</IonButton>
        <IonButton onClick={handleSignOutGia}>Lougout Gia</IonButton>
        <IonButton onClick={handleSignOut}>Expire WP Token</IonButton>
        <IonButton onClick={handleGetHouses}>Send WP Request</IonButton>
        <IonButton onClick={handleClearLogs}>Clear Logs</IonButton>
        <EnvCard />
        <AuthCard />
        <LogsCard logs={logs} />
        <ActionCard action={action}></ActionCard>
        {user && <UserInfoCard user={user}></UserInfoCard>}
      </IonContent>
    </AppPage>
  );
};

export default DebugPage;
